import { AIBadgeButton } from 'ai-components-ui-library/components/buttons/AIBadgeButton';
import styled from 'styled-components';
import { useState } from 'react';
import { SmartPropertyCitationPopover } from 'property-value-citations/public/SmartPropertyCitationPopover';
import { useAIProcessingMetadata } from 'customer-data-properties/ai/useAIProcessingMetadata';
import { EventBarrier } from '../../utils/EventBarrier';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSmartFillPropertyValueIndicator = styled.span.withConfig({
  displayName: "SmartFillPropertyValueIndicator__StyledSmartFillPropertyValueIndicator"
})(["cursor:default;overflow:hidden;transition:max-width 0.1s ease-in,opacity 0.1s ease-in;", ""], ({
  $isVisible
}) => $isVisible ? `
          max-width: 100px;
          opacity: 1;
          pointer-events: auto;
          transition-delay: 0s;
          visibility: visible;
        ` : `
          max-width: 0;
          opacity: 0;
          pointer-events: none;
          transition-delay: 0s, 300ms;
          visibility: hidden;
        `);
export const SmartFillPropertyValueIndicator = ({
  isParentHovered,
  metadataKey,
  smartPropertyResultId
}) => {
  var _metadata$metadataKey;
  const [open, setOpen] = useState(false);
  const metadata = useAIProcessingMetadata();
  const handleClick = () => setOpen(prev => !prev);
  const handleEventCapture = event => {
    event.stopPropagation();
  };
  const handleOpenChange = event => {
    setOpen(event.target.value);
  };
  const isPending = (metadata === null || metadata === void 0 || (_metadata$metadataKey = metadata[metadataKey]) === null || _metadata$metadataKey === void 0 ? void 0 : _metadata$metadataKey.status) === 'pending';
  const isVisible = isParentHovered && !isPending || open;
  return /*#__PURE__*/_jsx(EventBarrier, {
    onEventCapture: handleEventCapture,
    children: /*#__PURE__*/_jsx(SmartPropertyCitationPopover, {
      onOpenChange: handleOpenChange,
      open: open,
      smartPropertyResultId: smartPropertyResultId,
      children: /*#__PURE__*/_jsx(StyledSmartFillPropertyValueIndicator, {
        $isVisible: isVisible,
        children: /*#__PURE__*/_jsx(AIBadgeButton, {
          onClick: handleClick,
          use: "outlined"
        })
      })
    })
  });
};